import React from "react";
import { withRouter } from "cci-utility";
import Button from "./Button";

/**
 * Button that goes back in the router history, displayed with an arrow pointing left.
 */
const BackButton = ({ history }) => (
  <Button
    ui="link"
    leftIcon="chevron-left"
    paddings="10px"
    onPress={ () => history.goBack() }
  />
);

export default withRouter(BackButton);
